// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"ServicesMenuPage_iconWrapper__8sOa-"};